import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import withStyles from '@mui/styles/withStyles';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

// @mui/icon components
import RightArrowIcon from '@mui/icons-material/ArrowRightAlt';

import { addAlertSubscription, modifyAlertSubscription, removeAlertSubscription } from '../store/slices/alertsSlice';
import { setApiResponseInfo } from '../store/slices/apiResponseInfoSlice';

import { createStdRequest, apiFetch, showAlert } from '../utils/utils';

import DA from '../store/ReduxAccess';
import ReduxLoader from '../store/ReduxLoader';

import AlertModal from './AlertModal';
import KSelect from './KSelect';

const alertsPanelStyle = (theme) => ({
  root: {
    margin: '12px',
    fontSize: '112%',
  },
  panelTitle: {
    padding: '8px 0',
    borderBottom: '2px solid #4ec',
  },
  userSelectorRow: {
    margin: '20px 12px',
  },
  userSelectLabel: {
    fontWeight: 500,
    float: 'left',
    marginTop: '4px',
  },
  userSelect: {
    width: '240px',
    display: 'inline-block',
    marginLeft: '12px',
  },
  alertsTable: {
    marginTop: '16px',
    borderCollapse: 'collapse',
    padding: '40px',
    border: '1px solid #ddd',
  },
  alertsTableQuasiHeader: {
    backgroundColor: '#ddd',
    height: '42px',
  },
  tableBoldLead: {
    fontWeight: 500,
    paddingLeft: '14px',
  },
  alertsTableEventRow: {
    borderBottom: '1px solid #eee',
  },
  eventLabelDiv: {
    width: '540px',
  },
  eventArrow: {
    marginBottom: '-7px',
  },
  descriptionTd: {
    paddingLeft: '28px',
  },
  labeledCheckboxTd: {},
});

class PageHeader extends Component {
  render() {
    const classes = this.props.classes;
    return <div className={classes.panelTitle}>Alert Settings Details</div>;
  }
}

class UserSelect extends Component {
  render() {
    const { panel } = this.props;
    const { userId } = panel.state;
    const { classes } = panel.props;
    const allUsersInfo = DA.getAllFirmUsers();

    const options = allUsersInfo.map((info) => info.name);
    const values = allUsersInfo.map((info) => info.id);

    return (
      <div className={classes.userSelect}>
        <KSelect
          id="select-user"
          fullWidth={true}
          liveOptions={options}
          liveValues={values}
          value={userId}
          onChange={(event) => panel.setState({ userId: event.target.value })}
        />
      </div>
    );
  }
}

class UserSelectorRow extends Component {
  render() {
    const { panel } = this.props;
    const { classes } = panel.props;
    return (
      <div className={classes.userSelectorRow}>
        <div className={classes.userSelectLabel}>User</div>
        <UserSelect panel={panel} />
      </div>
    );
  }
}

class LabeledCheckbox extends Component {
  render() {
    const { classes, label, checked, value, onChange } = this.props;
    return (
      <FormControlLabel
        className={classes.labeledCheckbox}
        control={<Checkbox checked={checked} value={value} onChange={onChange} color="primary" />}
        label={label}
      />
    );
    // return <div className={classes.labeledCheckbox}>[] {this.props.label}</div>;
    /*
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={item.checked}
                      onChange={item.toggleFunc}
                      value={item.name}
                      color="primary"
                    />
                  }
                  label={item.label}
                />
        */
  }
}

class CategoryTableSection extends Component {
  render() {
    const { category, panel } = this.props;
    const { classes, alerts } = panel.props;
    const eventsForThisCategory = alerts.events.filter((ev) => ev.categoryId === category.id);
    return (
      <div>
        <tr>
          <td className={classes.tableBoldLead}>{category.name}</td>
          <td />
          <td />
          <td />
        </tr>
        {eventsForThisCategory.map((event) => (
          <EventRow key={event.id} event={event} panel={panel} />
        ))}
      </div>
    );
  }
}

class EventLabel extends Component {
  render() {
    const { classes, event } = this.props;
    return (
      <div className={classes.eventLabelDiv}>
        <RightArrowIcon className={classes.eventArrow} />
        {event.description}
      </div>
    );
  }
}

class EventRow extends Component {
  showTaskCreationCheckbox = false;

  getSubscription(subscriptions, alertableEvent, userId) {
    return subscriptions.find((s) => s.userId === userId && s.eventId === alertableEvent.id);
  }

  modifyOrDeleteSubscription(subscription, viaText, viaEmail, viaTask) {
    const { modifyAlertSubscription, removeAlertSubscription } = this.props.panel.props;
    const uri = `/api/alert/${subscription.id}`;
    if (!(viaText || viaEmail || viaTask)) {
      const request = createStdRequest(uri, 'DELETE');
      const actionOnGoodResponse = (json) => {
        removeAlertSubscription(subscription.id);
      };
      apiFetch(this, request, actionOnGoodResponse);
    } else {
      const apiStruct = {
        alertSubscriptionId: subscription.id,
        alertableEventId: subscription.eventId,
        userId: subscription.userId,
        firmId: subscription.firmId,
        viaText,
        viaEmail,
        viaTask,
      };
      const request = createStdRequest(uri, 'PUT', apiStruct);
      const actionOnGoodResponse = (json) => {
        const reduxSubscrip = ReduxLoader.convertAlertSubscriptionToReduxForm(json);
        modifyAlertSubscription(reduxSubscrip);
      };
      apiFetch(this, request, actionOnGoodResponse);
    }
  }

  createSubscription(eventId, userId, firmId, viaText, viaEmail, viaTask) {
    const uri = '/api/alert';
    const apiStruct = {
      alertableEventId: eventId,
      userId,
      firmId,
      viaText,
      viaEmail,
      viaTask,
    };
    const request = createStdRequest(uri, 'POST', apiStruct);
    const actionOnGoodResponse = (json) => {
      const reduxSubscrip = ReduxLoader.convertAlertSubscriptionToReduxForm(json);
      this.props.panel.props.addAlertSubscription(reduxSubscrip);
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  toggleSmsAlerts(userEvent) {
    const { panel, event } = this.props;
    const { alerts, firmId } = panel.props;
    const { subscriptions } = alerts;
    const { userId } = panel.state;
    const subscription = this.getSubscription(subscriptions, event, userId);
    const isNowChecked = userEvent.target.checked;
    if (subscription) {
      this.modifyOrDeleteSubscription(subscription, isNowChecked, subscription.viaEmail, subscription.viaTask);
    } else {
      this.createSubscription(event.id, userId, firmId, isNowChecked, false, false);
    }
  }

  toggleEmailAlerts(userEvent) {
    const { panel, event } = this.props;
    const { alerts, firmId } = panel.props;
    const { subscriptions } = alerts;
    const { userId } = panel.state;
    const subscription = this.getSubscription(subscriptions, event, userId);
    const isNowChecked = userEvent.target.checked;
    if (subscription) {
      this.modifyOrDeleteSubscription(subscription, subscription.viaText, isNowChecked, subscription.viaTask);
    } else {
      this.createSubscription(event.id, userId, firmId, false, isNowChecked, false);
    }
  }

  toggleTaskCreation(userEvent) {
    const { panel, event } = this.props;
    const { alerts, firmId } = panel.props;
    const { subscriptions } = alerts;
    const { userId } = panel.state;
    const subscription = this.getSubscription(subscriptions, event, userId);
    const isNowChecked = userEvent.target.checked;
    if (subscription) {
      this.modifyOrDeleteSubscription(subscription, subscription.viaText, subscription.viaEmail, isNowChecked);
    } else {
      this.createSubscription(event.id, userId, firmId, false, false, isNowChecked);
    }
  }

  render() {
    const { panel, event } = this.props;
    const { classes, alerts } = panel.props;
    const { subscriptions } = alerts;
    const { userId } = panel.state;
    const subscription = this.getSubscription(subscriptions, event, userId);
    const viaText = !!(subscription && subscription.viaText);
    const viaEmail = !!(subscription && subscription.viaEmail);
    const viaTask = !!(subscription && subscription.viaTask);
    return (
      <tr className={classes.alertsTableEventRow}>
        <td className={classes.descriptionTd}>
          <EventLabel classes={classes} event={event} />
        </td>
        <td className={classes.labeledCheckboxTd}>
          <LabeledCheckbox
            key={0}
            classes={classes}
            label="SMS Alerts"
            checked={viaText}
            value="smsAlerts"
            onChange={(event) => this.toggleSmsAlerts(event)}
          />
        </td>
        <td className={classes.labeledCheckboxTd}>
          <LabeledCheckbox
            key={1}
            classes={classes}
            label="Email Alerts"
            checked={viaEmail}
            value="emailAlerts"
            onChange={(event) => this.toggleEmailAlerts(event)}
          />
        </td>
        {this.showTaskCreationCheckbox ? (
          <td className={classes.labeledCheckboxTd}>
            <LabeledCheckbox
              key={2}
              classes={classes}
              label="Task Creation"
              checked={viaTask}
              value="taskCreation"
              onChange={(event) => this.toggleTaskCreation(event)}
            />
          </td>
        ) : (
          <td />
        )}
      </tr>
    );
  }
}

class AlertsTable extends Component {
  state = {};
  showGlobalToggles = false;
  nonSupportMessage = 'Support for global alerts is not yet implemented';

  handleAllSmsClick(userEvent) {
    showAlert(this, this.nonSupportMessage);
  }

  handleAllEmailClick(userEvent) {
    showAlert(this, this.nonSupportMessage);
  }

  handleAllTaskClick(userEvent) {
    showAlert(this, this.nonSupportMessage);
  }

  render() {
    const { panel } = this.props;
    const { classes, alerts } = panel.props;
    return (
      <div>
        <AlertModal renderer={this} show={this.state.shouldShowAlertModal} text={this.state.alertModalText} />
        <table className={classes.alertsTable}>
          <tbody>
            <tr className={classes.alertsTableQuasiHeader}>
              <td className={classes.tableBoldLead}>Alerts</td>
              {this.showGlobalToggles ? (
                <td className={classes.labeledCheckboxTd}>
                  <LabeledCheckbox
                    classes={classes}
                    label="Select All SMS"
                    value="globalSmsAlert"
                    checked={false}
                    onChange={(event) => this.handleAllSmsClick(event)}
                  />
                </td>
              ) : (
                <td />
              )}
              {this.showGlobalToggles ? (
                <td className={classes.labeledCheckboxTd}>
                  <LabeledCheckbox
                    classes={classes}
                    label="Select All Email"
                    value="globalEmailAlert"
                    checked={false}
                    onChange={(event) => this.handleAllEmailClick(event)}
                  />
                </td>
              ) : (
                <td />
              )}
              {this.showGlobalToggles ? (
                <td className={classes.labeledCheckboxTd}>
                  <LabeledCheckbox
                    classes={classes}
                    label="Select All Task"
                    value="globalTaskCreation"
                    checked={false}
                    onChange={(event) => this.handleAllTaskClick(event)}
                  />
                </td>
              ) : (
                <td />
              )}
            </tr>
            {alerts.categories.map((categoryIdAndName) => (
              <CategoryTableSection key={categoryIdAndName.id} category={categoryIdAndName} panel={panel} />
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

class AlertsPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: '',
      redirect: undefined,
      userId: props.userInfo.userId,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.userInfo.userId !== prevProps.userInfo.userId) {
      this.setState({ userId: this.props.userInfo.userId });
    }
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} push />;
    }
    if (this.state.errorMessage) {
      return (
        <div>
          <h1 style={{ color: 'red' }}>Error Encountered</h1>
          <h3>{this.state.errorMessage}</h3>
        </div>
      );
    }

    const { classes, userInfo } = this.props;
    const isAdmin = userInfo.role === 'Admin';

    return (
      <div className={classes.root}>
        <PageHeader classes={classes} />
        {isAdmin && <UserSelectorRow panel={this} />}
        <AlertsTable panel={this} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userInfo: state.userInfo,
  firmToShow: state.firms.idOfFirmToShow,
  alerts: state.alerts,
});
const actionProducers = {
  addAlertSubscription,
  modifyAlertSubscription,
  removeAlertSubscription,
  setApiResponseInfo,
};
export default connect(mapStateToProps, actionProducers)(withStyles(alertsPanelStyle)(AlertsPanel));
